import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import axios from "axios";
import { FaEnvelope, FaLock, FaSignInAlt, FaTimes } from "react-icons/fa";

function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [stayLoggedIn, setStayLoggedIn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState(location.state?.message || "");

  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotMsg, setForgotMsg] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMsg("");

    if (!formData.email.includes("@")) {
      setError("البريد الإلكتروني غير صالح");
      setLoading(false);
      return;
    }

    try {
      const API_URL = window.location.hostname === 'localhost' ? 'http://localhost/api/login.php' : '/api/login.php';
      
      const response = await axios.post(API_URL, {
        email: formData.email,
        password: formData.password
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.status === "success") {
        setLoading(false);
        const userData = response.data.user;
        
        const storageOptions = stayLoggedIn ? localStorage : sessionStorage;
        storageOptions.setItem("isLoggedIn", "true");
        storageOptions.setItem("userData", JSON.stringify(userData));
        
        if (!stayLoggedIn) {
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("userData");
        }
        
        if (userData.terms_accepted == 1) {
          window.location.href = "/dashboard";
        } else {
          window.location.href = "/terms-consent";
        }
      }
    } catch (err) {
      setLoading(false);
      setError(err.response?.data?.message || "حدث خطأ أثناء الاتصال بالسيرفر");
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setForgotLoading(true);
    setForgotMsg("");

    try {
      const API_URL = window.location.hostname === 'localhost' ? 'http://localhost/api/forgot_password.php' : '/api/forgot_password.php';
      const response = await axios.post(API_URL, { email: forgotEmail }, { headers: { 'Content-Type': 'application/json' } });

      if (response.data.status === "success") {
        setForgotMsg("تم إرسال طلب استعادة كلمة المرور للإدارة بنجاح.");
      } else {
        setForgotMsg(response.data.message || "حدث خطأ.");
      }
    } catch (err) {
      setForgotMsg(err.response?.data?.message || "خطأ في الاتصال بالسيرفر.");
    } finally {
      setForgotLoading(false);
    }
  };

  const ForgotModal = () => (
    <div className="terms-modal-overlay">
      <div className="terms-modal-content glass-card" style={{ maxWidth: '400px' }}>
        <button className="close-btn" onClick={() => setShowForgotModal(false)}><FaTimes /></button>
        <h2>نسيت كلمة المرور؟</h2>
        <p style={{ color: '#cbd5e1', marginBottom: '20px', textAlign: 'center' }}>
          أدخل بريدك الإلكتروني ليتم إرسال طلب لإدارة CodiCal بتعيين كلمة مرور جديدة لك.
        </p>
        <form onSubmit={handleForgotPassword} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input type="email" placeholder="البريد الإلكتروني" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} required />
          </div>
          {forgotMsg && <p className="error-message" style={{ background: forgotMsg.includes("بنجاح") ? 'rgba(76, 175, 80, 0.1)' : '', color: forgotMsg.includes("بنجاح") ? '#4CAF50' : '' }}>{forgotMsg}</p>}
          <button type="submit" className="auth-btn" disabled={forgotLoading}>
            {forgotLoading ? <span className="spinner"></span> : "إرسال الطلب"}
          </button>
        </form>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-container glass-card">
        <div className="auth-header">
          <FaSignInAlt className="auth-icon" />
          <h2>تسجيل الدخول</h2>
          <p>مرحباً بعودتك إلى لوحة تحكم CodiCal</p>
        </div>

        {successMsg && <p className="success-message fade-in">{successMsg}</p>}

        <form onSubmit={handleSignIn} className="auth-form">
          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input type="email" name="email" placeholder="البريد الإلكتروني" required value={formData.email} onChange={handleChange} />
          </div>

          <div className="input-group">
            <FaLock className="input-icon" />
            <input type="password" name="password" placeholder="كلمة المرور" required value={formData.password} onChange={handleChange} />
          </div>

          <div className="auth-options">
            <div className="terms-checkbox-group">
              <input type="checkbox" id="stayLoggedIn" checked={stayLoggedIn} onChange={(e) => setStayLoggedIn(e.target.checked)} />
              <label htmlFor="stayLoggedIn">تذكرني (البقاء مسجلاً)</label>
            </div>
            <a href="#!" className="forgot-link" onClick={(e) => { e.preventDefault(); setShowForgotModal(true); }}>نسيت كلمة المرور؟</a>
          </div>

          {error && <p className="error-message fade-in">{error}</p>}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? <span className="spinner"></span> : "الدخول"}
          </button>
        </form>

        <div className="auth-footer">
          <p>ليس لديك حساب؟ <Link to="/signup">إنشاء حساب جديد</Link></p>
        </div>
      </div>

      {showForgotModal && <ForgotModal />}

      <style>{`
        .auth-page {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: var(--bg-color);
          padding: 40px 20px;
          font-family: 'Tajawal', sans-serif;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .auth-page::before {
          content: "";
          position: absolute;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(14,116,171,0.2) 0%, rgba(14,116,171,0) 70%);
          top: -100px;
          left: -100px;
          border-radius: 50%;
          z-index: 0;
        }

        .glass-card {
          background: var(--card-bg);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid var(--border-color);
          border-radius: 20px;
          box-shadow: 0 15px 35px rgba(0,0,0,0.1);
          z-index: 1;
        }

        .auth-container {
          width: 100%;
          max-width: 450px;
          padding: 40px;
          color: var(--text-color);
          animation: slideUp 0.6s ease-out;
        }

        .auth-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .auth-icon {
          font-size: 40px;
          color: #38bdf8;
          margin-bottom: 15px;
        }

        .auth-header h2 {
          font-size: 28px;
          margin-bottom: 10px;
          font-weight: 700;
        }

        .auth-header p {
          color: #94a3b8;
          font-size: 15px;
        }

        .auth-form {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .input-group {
          position: relative;
          display: flex;
          align-items: center;
        }

        .input-icon {
          position: absolute;
          right: 20px;
          color: #94a3b8;
          transition: color 0.3s;
        }

        .input-group input {
          width: 100%;
          padding: 15px 50px 15px 20px;
          background: rgba(14, 116, 171, 0.05); /* slightly tinted explicitly visible in light/dark */
          border: 1px solid rgba(14, 116, 171, 0.2);
          border-radius: 12px;
          color: var(--card-text, #333);
          font-size: 15px;
          transition: all 0.3s ease;
        }

        .input-group input:focus {
          outline: none;
          border-color: #38bdf8;
          background: rgba(255, 255, 255, 0.08);
          box-shadow: 0 0 15px rgba(56, 189, 248, 0.2);
        }

        .input-group input:focus + .input-icon {
          color: #38bdf8;
        }

        .auth-options {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .terms-checkbox-group {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14px;
          color: #cbd5e1;
        }

        .terms-checkbox-group input[type="checkbox"] {
          width: 16px;
          height: 16px;
          accent-color: #38bdf8;
          cursor: pointer;
        }

        .forgot-link {
          color: #38bdf8;
          text-decoration: none;
          font-size: 14px;
          font-weight: 600;
          transition: color 0.3s;
        }

        .forgot-link:hover {
          color: #7dd3fc;
        }

        .auth-btn {
          padding: 15px;
          background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          justify-content: center;
          align-items: center;
          box-shadow: 0 4px 15px rgba(2, 132, 199, 0.4);
        }

        .auth-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(2, 132, 199, 0.6);
        }

        .auth-btn:disabled {
          background: #475569;
          box-shadow: none;
          cursor: not-allowed;
          opacity: 0.7;
        }

        .auth-footer {
          margin-top: 25px;
          text-align: center;
          color: #94a3b8;
          font-size: 15px;
        }

        .auth-footer a {
          color: #38bdf8;
          font-weight: 600;
          text-decoration: none;
          margin-right: 5px;
          transition: color 0.3s;
        }

        .auth-footer a:hover {
          color: #7dd3fc;
        }

        .error-message {
          background: rgba(239, 68, 68, 0.1);
          color: #f87171;
          padding: 12px;
          border-radius: 8px;
          text-align: center;
          font-size: 14px;
          border: 1px solid rgba(239, 68, 68, 0.2);
        }

        .success-message {
          background: rgba(76, 175, 80, 0.1);
          color: #4CAF50;
          padding: 12px;
          border-radius: 8px;
          text-align: center;
          font-size: 14px;
          margin-bottom: 20px;
          border: 1px solid rgba(76, 175, 80, 0.2);
        }

        .spinner {
          width: 20px;
          height: 20px;
          border: 3px solid rgba(255,255,255,0.3);
          border-radius: 50%;
          border-top-color: white;
          animation: spin 1s ease-in-out infinite;
        }

        /* Terms Modal / Forgot Modal */
        .terms-modal-overlay {
          position: fixed;
          top: 0; left: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          backdrop-filter: blur(5px);
        }

        .terms-modal-content {
          width: 90%;
          padding: 30px;
          position: relative;
          display: flex;
          flex-direction: column;
          background: #1e293b;
          color: white;
        }

        .close-btn {
          position: absolute;
          top: 15px;
          left: 15px;
          background: none;
          border: none;
          color: #94a3b8;
          font-size: 24px;
          cursor: pointer;
          transition: color 0.3s;
        }

        .close-btn:hover { color: white; }

        .terms-modal-content h2 {
          text-align: center;
          color: #38bdf8;
          margin-bottom: 20px;
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        @media (max-width: 600px) {
          .auth-container { padding: 30px 20px; }
        }
      `}</style>
    </div>
  );
}

export default SignIn;